import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { CATEGORY_LABELS } from "../lib/api";

const REUNION_CENTER = [-21.1151, 55.5364];

function makeIcon(place) {
  const cls = place.is_promoted ? "promoted" : `cat-${place.category}`;
  return L.divIcon({
    className: "",
    html: `<div class="custom-pin ${cls}"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg></div>`,
    iconSize: [34, 34],
    iconAnchor: [17, 34],
    popupAnchor: [0, -30],
  });
}

function FlyTo({ target }) {
  const map = useMap();
  useEffect(() => {
    if (target) map.flyTo([target.lat, target.lng], 14, { duration: 1.2 });
  }, [target, map]);
  return null;
}

export default function MapView({ places, focused, zoom = 10, interactive = true }) {
  return (
    <MapContainer
      center={REUNION_CENTER}
      zoom={zoom}
      className="w-full h-full"
      style={{ height: "100%", width: "100%", zIndex: 0 }}
      zoomControl={interactive}
      scrollWheelZoom={interactive}
      dragging={interactive}
      doubleClickZoom={interactive}
      data-testid="reunion-map"
    >
      <TileLayer
        attribution='&copy; OpenStreetMap'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {places.map((p) => (
        <Marker key={p.id} position={[p.lat, p.lng]} icon={makeIcon(p)}>
          <Popup>
            <div className="min-w-[200px]" data-testid={`map-popup-${p.id}`}>
              {p.image_url && (
                <img src={p.image_url} alt={p.name} className="w-full h-24 object-cover rounded-lg mb-2" />
              )}
              <div className="uppercase-label text-[#FF6B35]">{CATEGORY_LABELS[p.category]}</div>
              <div className="font-display font-bold text-base text-[#1A1A1A] mt-0.5">{p.name}</div>
              <div className="flex items-center gap-1 text-xs text-[#1A1A1A]/60 mt-1">
                <Star size={12} className="fill-[#FF6B35] text-[#FF6B35]" />
                <span>{p.rating?.toFixed(1)}</span>
                <span>·</span>
                <span>{p.city}</span>
              </div>
              <Link to={`/place/${p.id}`} data-testid={`popup-detail-${p.id}`}
                className="mt-2 inline-block text-xs font-bold text-[#FF6B35] hover:underline">
                Voir le détail →
              </Link>
            </div>
          </Popup>
        </Marker>
      ))}
      <FlyTo target={focused} />
    </MapContainer>
  );
}
